import React from 'react';
import ContinentView from './ContinentView';

import northeast from '../assets/northamerica.jpg';
import midwest from '../assets/midwest.jpg';
import west from '../assets/la.jpg';
import southcentral from '../assets/southcentral.JPG';
import jamaica from '../assets/jamaica.jpg';
import southeast from '../assets/southeast.jpg';
import canada from '../assets/canada.jpg';

const destinations = [
  { name: 'North East', region: 'NorthEast', image: northeast },
  { name: 'Mid West', region: 'MidWest', image: midwest },
  { name: 'West', region: 'West', image: west },
  { name: 'South Central', region: 'SouthCentral', image: southcentral },
  { name: 'South East', region: 'SouthEast', image: southeast },
  { name: 'Jamaica', region: 'Jamaica', image: jamaica },
  { name: 'Canada', region: 'Canada', image: canada },
];

const NorthAmerica = () => (
  <ContinentView
    continentName="North America"
    bannerImage={northeast}
    description="Explore North America with The Half Time Travel. Discover the Northeast, Midwest, West, South Central, Southeast, Jamaica, and Canada."
    destinations={destinations}
  />
);

export default NorthAmerica;